import MStockHomePage from '@pages/MStockHomePage.jsx'
import Loadable from '@components/common/loadable.jsx'
import { lazy } from 'react'
import { MStockLayout } from '@templates/layout/MStockLayout.jsx'

const MStockDetailPage = Loadable(lazy(() => import('@pages/MStockDetailPage.jsx')))
const MarketCapListPage = Loadable(lazy(() => import('@pages/MarketCapListPage.jsx')))
const MStockNewsListPage = Loadable(lazy(() => import('@pages/MStockNewsListPage.jsx')))
const MStockNewsDetailPage = Loadable(lazy(() => import('@pages/MStockNewsDetailPage.jsx')))

const targetRoutes = [
  {
    element: <MStockLayout />,
    children: [
      {
        path: 'main',
        element: <MStockHomePage />
      },
      {
        path: 'mstock',
        children: [
          { path: 'market-cap', element: <MarketCapListPage /> },
          {
            path: 'stock/all/:assetId',
            element: <MStockDetailPage />
          },
          {
            path: 'news',
            children: [
              { index: true, element: <MStockNewsListPage /> },
              { path: ':key', element: <MStockNewsDetailPage /> }
            ]
          }
        ]
      }
    ]
  }
]

export default targetRoutes
